import { ILiveSheetState } from './ILiveSheetState';
import { PayloadAction } from '@reduxjs/toolkit';
import { ILayer } from './LayersState';
import { addLayersReducer } from './addLayerReducers';

export function pasteLayersReducer(state: ILiveSheetState, action: PayloadAction<ILayer[]>) {
  addLayersReducer(state, action);
  state.transform = null;
}
